/**
 * @generated SignedSource<<1bd2d1c11aa1faa470e5052c133d90c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSaveNoteImageOrgGetImageLinkMutation$variables = {
  workspaceId: string;
};
export type useSaveNoteImageOrgGetImageLinkMutation$data = {
  readonly workspace: {
    readonly uploadImageLink: {
      readonly image: {
        readonly id: string;
      };
      readonly url: string;
    };
  };
};
export type useSaveNoteImageOrgGetImageLinkMutation = {
  response: useSaveNoteImageOrgGetImageLinkMutation$data;
  variables: useSaveNoteImageOrgGetImageLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "workspaceId"
      }
    ],
    "concreteType": "WorkspaceMutation",
    "kind": "LinkedField",
    "name": "workspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveNoteImageOrgGetImageLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSaveNoteImageOrgGetImageLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9da90a13f0a4e0d0df64f8b0590d43dd",
    "id": null,
    "metadata": {},
    "name": "useSaveNoteImageOrgGetImageLinkMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveNoteImageOrgGetImageLinkMutation(\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    uploadImageLink {\n      image {\n        id\n      }\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba16c9ae4dad5a8f8526804797f073e0";

export default node;
